import { useEffect, useRef, useState } from "react";

const bullets = [
  {
    icon: "ri-map-pin-user-line",
    title: "Why Your Ideal Clients Are Booking Your Competitors",
    body: "A breakdown of where your ideal clients are and why they\u2019re booking your competitors instead of you.",
    delay: 0,
  },
  {
    icon: "ri-error-warning-line",
    title: "The #1 Paid Ads Mistake Med Spas Are Making",
    body: "The #1 paid ads mistake med spas in your area are making right now and how to turn that around on the spot.",
    delay: 120,
  },
  {
    icon: "ri-calendar-check-line",
    title: "Your Personalized 30-Day Action Plan",
    body: "A simple action plan to get 10\u201330 new bookings in the next 30 days.",
    delay: 240,
  },
];

export default function BulletsSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className="py-24 px-6"
      style={{ background: "#1C1C1C" }}
    >
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div
          className="text-center mb-16"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(24px)",
            transition: "opacity 0.7s ease, transform 0.7s ease",
          }}
        >
          <span
            className="inline-block text-xs font-semibold tracking-widest uppercase mb-4 px-4 py-1.5 rounded-full"
            style={{
              background: "rgba(201, 149, 111, 0.15)",
              color: "#C9956F",
              border: "1px solid rgba(201, 149, 111, 0.3)",
              fontFamily: "'Inter', sans-serif",
            }}
          >
            What You'll Walk Away With
          </span>
          <h2
            className="text-3xl md:text-4xl font-bold text-white"
            style={{ fontFamily: "'Playfair Display', serif", letterSpacing: "-0.01em" }}
          >
            In 15 Minutes, You'll Get All Three
          </h2>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-6">
          {bullets.map((b) => (
            <div
              key={b.title}
              className="rounded-lg p-8 flex flex-col gap-5"
              style={{
                background: "#252525",
                border: "1px solid #333",
                opacity: visible ? 1 : 0,
                transform: visible ? "translateY(0)" : "translateY(32px)",
                transition: `opacity 0.75s ease ${b.delay}ms, transform 0.75s ease ${b.delay}ms`,
              }}
            >
              <div
                className="w-12 h-12 flex items-center justify-center rounded-full"
                style={{ background: "rgba(201, 149, 111, 0.12)", border: "1px solid rgba(201, 149, 111, 0.25)" }}
              >
                <i className={`${b.icon} text-xl`} style={{ color: "#C9956F" }} />
              </div>

              <div>
                <h3
                  className="text-lg font-semibold text-white mb-3 leading-snug"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {b.title}
                </h3>
                <p
                  className="text-sm leading-relaxed"
                  style={{ color: "#A0A0A0", fontFamily: "'Inter', sans-serif" }}
                >
                  {b.body}
                </p>
              </div>

              <div className="mt-auto flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center rounded-full" style={{ background: "#C9956F" }}>
                  <i className="ri-check-line text-xs text-white" />
                </div>
                <span className="text-xs font-medium" style={{ color: "#C9956F", fontFamily: "'Inter', sans-serif" }}>
                  Included in your free audit
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Human Element */}
        <div
          className="mt-16 flex flex-col items-center gap-5"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(24px)",
            transition: "opacity 0.8s ease 360ms, transform 0.8s ease 360ms",
          }}
        >
          <div className="w-px h-10" style={{ background: "linear-gradient(to bottom, transparent, rgba(201,149,111,0.4))" }} />
          <div
            className="w-20 h-20 rounded-full overflow-hidden flex-shrink-0"
            style={{ border: "2px solid rgba(201, 149, 111, 0.5)" }}
          >
            <img
              src="https://storage.readdy-site.link/project_files/176b8c5d-519b-49f5-ae57-58286d1a3153/0e8ddf8b-1d81-4845-bf97-2b4907fc3b99_Heahshot-LP.png?v=c1738d7937f59ec8691b58943b306c65"
              alt="Guilherme"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="text-center">
            <p
              className="text-base font-semibold text-white"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Guilherme Oliveira
            </p>
            <p
              className="text-sm mt-1"
              style={{ color: "#C9956F", fontFamily: "'Inter', sans-serif", letterSpacing: "0.04em" }}
            >
              Med Spa Growth Specialist
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
